<template>
    <div class="site min-h-screen flex flex-row">
        <a href="#main-content" class="sr-only focus:not-sr-only focus:fixed focus:z-[9999] focus:top-2 focus:left-2 focus:px-4 focus:py-2 focus:bg-yellow-400 focus:text-black focus:rounded">Skip to main content</a>
        <Navigation />
        <div class="flex-1 flex flex-col min-w-0">
            <main id="main-content" class="flex-1 mx-auto flex flex-wrap justify-center w-full px-2 py-2 pt-12 lg:pt-2">
                <slot></slot>
            </main>
            <footer class="text-amber-700 self-start px-4">
                <div>&copy;{{ formatDate(today, 'YYYY') }} Adam Wood. <Link href="/contact">API credits</Link></div>
            </footer>
        </div>
        <music-player :show-audio-duration="true" :repeat-all="true" :show-audio-data="true" :playlist="playlist" class="fixed bottom-0 left-1/2 -translate-x-1/2 z-90"/>
    </div>
</template>
<script>
import { mapActions, mapWritableState } from 'pinia';
import { useGeneralStore } from '@/utils/useGeneralStore';
import { basketballStore } from '@/utils/basketballStore';
import { formatDate } from '@/utils/Utilities';
import Navigation from '@/Components/Navigation.vue';
import { Link } from '@inertiajs/vue3';
import MusicPlayer from '@/Components/MusicPlayer.vue';
import dayjs from 'dayjs';

export default {
    components: { Link, MusicPlayer, Navigation },
    computed: {
        ...mapWritableState(useGeneralStore, ['latestBirds', 'latestBirdsUpdate']),
        ...mapWritableState(basketballStore, ['selectedConference', 'selectedTeam', 'selectedPlayer', 'lastUpdate', 'gamesOnNow', 'todaysGames'])
    },
    props: ['conferences', 'conference', 'team', 'teams', 'player'],
    data() {
        return {
            today: dayjs(),
            modules: [],
            playlist: [
                    { audio: '/player?file=Punch Elon.mp3', artist: 'ACW', title: 'Punch Elon', album: null, cover: '/images/acw-smallhead.png' },
                    { audio: '/player?file=Red Shoe.mp3', artist: 'ACW', title: 'Red Shoe', album: null, cover: '/images/acw-smallhead.png' },
                    { audio: '/player?file=Sinking.mp3', artist: 'Shitcan Noisebelt', title: 'Sinking', album: null, cover: '/images/acw-smallhead.png' },
                    { audio: '/player?file=Shirt Check.mp3', artist: 'Shitcan Noisebelt', title: 'Shirt Check', album: null, cover: '/images/acw-smallhead.png' },
                    { audio: '/player?file=tronick.mp3', artist: 'ACW', title: 'Trajnick', album: null, cover: '/images/acw-smallhead.png' },
                    { audio: '/player?file=coroner-theHappiestofSad.mp3', artist: 'ACW', title: 'Coroner - The Happiest of Sad', album: null, cover: '/images/acw-smallhead.png' },
                    { audio: '/player?file=Downbeet.mp3', artist: 'ACW', title: 'Downbeet', album: null, cover: '/images/acw-smallhead.png' },
                    { audio: '/player?file=fobbler_1 - montage of motivation.mp3', artist: 'ACW', title: 'Montage of Motivation', album: null, cover: '/images/acw-smallhead.png' },
                    { audio: '/player?file=e coli - A Digital Meadow.mp3', artist: 'ACW', title: 'E Coli - A Digital Meadow', album: null, cover: '/images/acw-smallhead.png' },
                    { audio: '/player?file=fluggle - electronic heist.mp3', artist: 'ACW', title: 'Electronic Heist', album: null, cover: '/images/acw-smallhead.png' },
                ],
        }
    },
    mounted() {
        // if(~['MBBStandings', 'WBBStandings'].indexOf(this.$page.component)) {
        //     this.modules=['conference'];
        // }else{
        //     this.modules=['conference', 'team']
        // }
        // if(this.conference) {
        //     console.log('confconf', this.conference);
        //     this.selectedConference=this.conference;
        // }else{
        //     this.selectedConference=this.conferences[0];
        // }
        window.Echo.channel('bird')
            .listen('.watcher', (e) => {
                this.addTally(e.bird);
                this.latestBirdsUpdate=e.date;
        });
        this.getBasketballs();
    },
    methods: {
        formatDate,
        ...mapActions(useGeneralStore, ['updateLatestBird']),
        getBasketballs() {
            window.Echo.channel("basketball")
                .listen(".basketballEvent", (e) => {
                    let gameIndex=this.gamesOnNow?.findIndex(gon => gon.id==e.game?.id);
                    this.gamesOnNow[gameIndex]=e.game;
                    this.lastUpdate=dayjs(e?.date).format('MM/DD/YYYY h:mm:ssa');
                    // let game=this.todaysGamesFiltered?.find(s => s.id == e.data?.id);
                    // if(game){
                //     game.period_detail=e.data.period_detail;
                    //     game.period=e.data.period;
                    //     game.home_team_score=e.data.home_team_score;
                    //     game.away_team_score=e.data.away_team_score;
                    //     game.away_team_h1=e.data.away_team_h1;
                    //     game.away_team_h2=e.data.away_team_h2;
                    //     game.home_team_h1=e.data.home_team_h1;
                    //     game.home_team_h2=e.data.home_team_h2;
                    // }
            });
        },
        addTally(bird) {
            const birdDate = dayjs(bird.datetime).format('YYYY-MM-DD');
            const birdHour = dayjs(bird.datetime).hour();
            let match = this.latestBirds?.findIndex(lb =>
                lb.scientific_name === bird.scientific_name &&
                lb.detection_date === birdDate &&
                Number(lb.detection_hour) === birdHour
            );
            if (match >= 0) {
                this.latestBirds[match].detections += 1;
                this.latestBirds[match].datetime = bird.datetime;
                if (Number(bird.confidence) > Number(this.latestBirds[match].confidence)) {
                    this.latestBirds[match].confidence = bird.confidence;
                }
            } else {
                this.latestBirds.unshift({
                    ...bird,
                    detection_date: birdDate,
                    detection_hour: birdHour,
                    detections: 1,
                });
            }
        }
    }

}

</script>
<style scoped>
.site {
    background-color: var(--primary-dark);
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80'%3E%3Cpath d='M40 0 L80 40 L40 80 L0 40 Z' fill='none' stroke='rgba(193,154,76,0.18)' stroke-width='1'/%3E%3Cpath d='M40 10 L70 40 L40 70 L10 40 Z' fill='none' stroke='rgba(193,154,76,0.12)' stroke-width='0.75'/%3E%3Cpath d='M40 20 L60 40 L40 60 L20 40 Z' fill='none' stroke='rgba(193,154,76,0.10)' stroke-width='0.5'/%3E%3Cpath d='M40 30 L50 40 L40 50 L30 40 Z' fill='rgba(193,154,76,0.06)' stroke='rgba(193,154,76,0.14)' stroke-width='0.5'/%3E%3Ccircle cx='40' cy='0' r='1.5' fill='rgba(193,154,76,0.28)'/%3E%3Ccircle cx='80' cy='40' r='1.5' fill='rgba(193,154,76,0.28)'/%3E%3Ccircle cx='40' cy='80' r='1.5' fill='rgba(193,154,76,0.28)'/%3E%3Ccircle cx='0' cy='40' r='1.5' fill='rgba(193,154,76,0.28)'/%3E%3C/svg%3E");
    background-size: 80px 80px;
    background-repeat: repeat;

}
nav ul {
    margin: 10px 3px 0;
}
nav ul li .menu-btn {
    color: white;
    padding: 6px 12px 4px;
    background-color: rgba(255,255,255,.5);
}
nav ul li .menu-btn:hover,
nav ul li .menu-btn.active {
    text-decoration: none;
    background-color: rgba(255,255,255,1);
    color: black;
}

.fader-enter-active,
.fader-leave-active {
  transition: opacity 0.5s ease;
}

.fader-enter-from,
.fader-leave-to {
  opacity: 0;
}
</style>
